<script>
    export let data;

    import {Button} from "carbon-components-svelte";
    import EnumStatus from "../services/taskstatus";
    import {updateTask} from "../store";
    import ManagedSolutions20 from "carbon-icons-svelte/lib/ManagedSolutions20";

    function updateTaskDo() {
        data.setStatus(EnumStatus.SOMEDAY);
        data = data;
        updateTask(data)
    }
    let taskid = data.id;
</script>

<Button kind="ghost" iconDescription="Someday" on:click={updateTaskDo} icon={ManagedSolutions20}
></Button
>
